import { PayloadAction } from '@reduxjs/toolkit';
import { AppState } from './appSlice';
import { getIAMBaseUrl, getMDSBaseUrl } from '../services/apiService';
import { apiCall, createApiThunk } from '../utils/api';

interface SetDarkThemePayload {
  isDark: boolean;
}

export const authLogoutThunk = createApiThunk('AUTH_LOGOUT', apiCall);
export const loginLogsThunk = createApiThunk('LOGIN_LOGS', apiCall);

export const setDarkThemeReducer = (
  state: AppState,
  action: PayloadAction<SetDarkThemePayload>,
) => {
  state.darkTheme = action.payload.isDark;
};

export const setIsLoadingReducer = (state: AppState, action: PayloadAction<boolean>) => {
  state.isLoading = action.payload;
};

export const authLogout = () => async (dispatch: AppDispatch) => {
  await dispatch(loginLogsThunk({ url: `${getMDSBaseUrl()}/v1/mds/user/logout`, method: 'PUT' }));
  await dispatch(authLogoutThunk({ url: `${getIAMBaseUrl()}/auth/logout`, method: 'GET' }));
};
